
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Urbaniaonrentinbanerpune() {



    const cardData =
    {
        keyword: 'Urbania on Rent in Baner Pune   ',
        heading: 'Amruta Travels: Urbania on Rent in Baner Pune',
        headingDescription: 'Amruta Travels offers Urbania on Rent in Baner Pune, providing a premium and comfortable group travel solution for corporate trips, family outings, airport transfers, school excursions, and weekend getaways. Our 13-seater and 17-seater Force Urbania vans feature spacious interiors, air-conditioning, and modern amenities to ensure a smooth and enjoyable journey. With professional drivers, punctual service, competitive pricing, and 24/7 support, Amruta Travels makes Urbania rental in Baner Pune safe, reliable, and hassle-free.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



"services": [
  {
    "name": "Urbania on rent in Baner Pune",
    "description": "Urbania on rent in Baner Pune offering premium and comfortable group transportation for corporate travel, family trips, airport transfers, weddings, and outstation journeys. Vehicles feature fully air-conditioned interiors, plush pushback seating, generous legroom, ample luggage space, clean cabins, and professional drivers to ensure smooth, safe, and punctual travel."
  },
  {
    "name": "Force Urbania on rent Baner",
    "description": "Force Urbania on rent in Baner providing luxury mini bus services for business and leisure needs. Well-maintained AC vehicles with modern interiors, spacious seating, excellent ride quality, and experienced drivers familiar with Baner, Balewadi, and nearby routes."
  },
  {
    "name": "Urbania rental service Baner Pune",
    "description": "Urbania rental service in Baner Pune delivering reliable, flexible, and affordable transport solutions. Ideal for corporate offices, IT companies, families, and tourists with AC comfort, clean interiors, and on-time service."
  },
  {
    "name": "Urbania Bus hire in Baner",
    "description": "Urbania bus hire in Baner for group travel such as corporate events, weddings, picnics, and tours. Spacious AC interiors, comfortable seating, safety features, and trained drivers ensure a relaxed journey."
  },
  {
    "name": "Urbania on rent near Baner Pune",
    "description": "Urbania on rent near Baner Pune with quick availability and doorstep pickup. Suitable for residential societies, executives, and tourists seeking luxury and dependable travel."
  },
  {
    "name": "13 seater Urbania on rent Baner",
    "description": "13 seater Urbania on rent in Baner ideal for family trips, airport transfers, and small corporate groups. AC interiors, pushback seats, sufficient luggage space, and professional chauffeurs included."
  },
  {
    "name": "17 seater Urbania on rent Baner",
    "description": "17 seater Urbania on rent in Baner for larger groups and corporate teams. Luxury AC interiors, spacious seating layout, ample legroom, and smooth ride quality ensure premium group travel."
  },
  {
    "name": "Luxury Urbania hire Baner Pune",
    "description": "Luxury Urbania hire in Baner Pune for premium travel needs such as VIP movement, weddings, and executive transport. Elegant AC interiors, plush seating, and disciplined drivers deliver a high-end experience."
  },
  {
    "name": "AC Urbania Bus hire Baner",
    "description": "AC Urbania bus hire in Baner offering cool, comfortable, and relaxed journeys. Ideal for all seasons with powerful air-conditioning, clean interiors, and comfortable seating."
  },
  {
    "name": "Force Urbania 17 seater Baner",
    "description": "Force Urbania 17 seater in Baner suitable for corporate travel, family outings, and outstation tours. Provides AC comfort, spacious interiors, luggage capacity, and skilled drivers."
  },
  {
    "name": "Urbania on rent near Balewadi",
    "description": "Urbania on rent near Balewadi for corporate, family, and airport travel. Luxury AC vehicles with punctual service and professional chauffeurs."
  },
  {
    "name": "Urbania hire near Baner Road",
    "description": "Urbania hire near Baner Road for easy access to city travel, airport transfers, and group tours with AC comfort and reliable service."
  },
  {
    "name": "Urbania rental near Pashan",
    "description": "Urbania rental near Pashan for residential and corporate travel needs. Clean AC interiors, spacious seating, and courteous drivers ensure smooth journeys."
  },
  {
    "name": "Urbania Bus hire near Aundh Baner",
    "description": "Urbania bus hire near Aundh Baner for family trips, weddings, corporate outings, and picnics. Offers spacious AC interiors and dependable service."
  },
  {
    "name": "Urbania on rent near Hinjewadi Phase 1",
    "description": "Urbania on rent near Hinjewadi Phase 1 for IT professionals and corporate guests. Premium AC vehicles with punctual pickups and drops."
  },
  {
    "name": "Urbania on rent Baner for corporate travels",
    "description": "Urbania on rent in Baner for corporate meetings, conferences, seminars, and employee transportation. Premium AC interiors and disciplined drivers meet corporate standards."
  },
  {
    "name": "Urbania hire Baner for airport transfer",
    "description": "Urbania hire in Baner for airport transfers with timely pickup and drop. Spacious AC interiors, luggage-friendly design, and airport-route experienced drivers."
  },
  {
    "name": "Urbania on rent Baner for family trip",
    "description": "Urbania on rent in Baner for family trips offering safety, comfort, and space. Ideal for vacations, outings, and temple visits."
  },
  {
    "name": "Urbania hire Baner for outstation",
    "description": "Urbania hire in Baner for outstation travel to Lonavala, Mahabaleshwar, Shirdi, Mumbai, and more with AC comfort and reliable vehicles."
  },
  {
    "name": "Urbania Bus hire Baner for wedding",
    "description": "Urbania bus hire in Baner for wedding transportation. Perfect for guest and family movement with luxury AC interiors and professional chauffeurs."
  },
  {
    "name": "Urbania airport pickup from Baner",
    "description": "Urbania airport pickup from Baner ensuring punctual arrivals, AC comfort, and sufficient luggage space for families and corporate guests."
  },
  {
    "name": "Urbania Pune Airport drop from Baner",
    "description": "Urbania Pune Airport drop service from Baner with timely departures, luxury AC interiors, and stress-free travel."
  },
  {
    "name": "Urbania corporate hire Baner Pune",
    "description": "Urbania corporate hire in Baner Pune for office travel, client meetings, and staff transportation. Premium AC vehicles and professional drivers."
  },
  {
    "name": "Urbania van hire Baner for IT companies",
    "description": "Urbania van hire in Baner for IT companies offering reliable and comfortable employee and guest transportation with AC comfort."
  },
  {
    "name": "Urbania on rent Baner price",
    "description": "Urbania on rent price in Baner offering transparent and competitive rates with premium AC vehicles and professional service."
  },
  {
    "name": "Urbania hire Baner per km rate",
    "description": "Urbania hire in Baner available on per km basis for local and outstation travel with flexible and affordable pricing."
  },
  {
    "name": "Affordable Urbania rental Baner",
    "description": "Affordable Urbania rental in Baner providing luxury travel at budget-friendly prices without compromising comfort or safety."
  },
  {
    "name": "Cheap Urbania on rent Baner",
    "description": "Cheap Urbania on rent in Baner for economical group travel with AC comfort, clean vehicles, and reliable drivers."
  },
  {
    "name": "Best Urbania rental service Baner",
    "description": "Best Urbania rental service in Baner known for luxury vehicles, experienced drivers, punctual service, and excellent customer satisfaction."
  },
  {
    "name": "Book Urbania on rent in Baner",
    "description": "Book Urbania on rent in Baner easily with flexible booking options, premium AC vehicles, and dependable service."
  },
  {
    "name": "Online Urbania booking Baner Pune",
    "description": "Online Urbania booking in Baner Pune for quick and hassle-free reservations with well-maintained vehicles and professional chauffeurs."
  },
  {
    "name": "13 Seater Urbania On Rent in Baner Pune",
    "description": "13 seater Urbania on rent in Baner Pune for families and small groups with AC comfort, luggage space, and experienced drivers."
  },
  {
    "name": "Luxury Force Urbania Hire Baner",
    "description": "Luxury Force Urbania hire in Baner delivering a premium travel experience with high-end AC interiors and courteous chauffeurs."
  },
  {
    "name": "Urbania Airport Transfer from Baner Pune",
    "description": "Urbania airport transfer service from Baner Pune providing timely pickup and drop with luxury AC vehicles and reliable drivers."
  }
],
"tableData": [
  ["Urbania on rent in Baner Pune", "Force Urbania on rent Baner"],
  ["Urbania rental service Baner Pune", "Urbania Bus hire in Baner"],
  ["13 seater Urbania on rent Baner", "17 seater Urbania on rent Baner"],
  ["Luxury Urbania hire Baner Pune", "AC Urbania Bus hire Baner"],
  ["Urbania on rent near Balewadi", "Urbania hire near Baner Road"],
  ["Urbania rental near Pashan", "Urbania Bus hire near Aundh Baner"],
  ["Urbania on rent near Hinjewadi Phase 1", "Urbania on rent Baner for corporate travels"],
  ["Urbania hire Baner for airport transfer", "Urbania on rent Baner for family trip"],
  ["Urbania hire Baner for outstation", "Urbania Bus hire Baner for wedding"],
  ["Urbania airport pickup from Baner", "Urbania Pune Airport drop from Baner"],
  ["Urbania corporate hire Baner Pune", "Urbania van hire Baner for IT companies"],
  ["Urbania hire Baner per km rate", "Affordable Urbania rental Baner"],
  ["Cheap Urbania on rent Baner", "Best Urbania rental service Baner"],
  ["Book Urbania on rent in Baner", "Online Urbania booking Baner Pune"],
  ["13 Seater Urbania On Rent in Baner Pune", "Urbania Airport Transfer from Baner Pune"]
],




"whychoose": [
  {
    "WhyChooseheading": "Reliable Urbania on Rent in Baner Pune",
    "WhyChoosedescription": "Amruta Travels offers Urbania on Rent in Baner Pune, providing stylish, comfortable, and dependable travel solutions for corporate trips, family outings, and group travel."
  },
  {
    "WhyChooseheading": "Perfect for Corporate, Family, and Event Travel",
    "WhyChoosedescription": "Whether it’s a corporate meeting, family outing, wedding transport, or city sightseeing, our Urbania rentals in Baner ensure a smooth and comfortable journey."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Interiors",
    "WhyChoosedescription": "Urbania vehicles feature plush seating, generous legroom, air conditioning, wide windows, and ample luggage space, making them ideal for short city rides and long-distance trips."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "All Urbania rentals come with trained and courteous drivers who ensure punctuality, safety, and a pleasant travel experience throughout Baner and Pune."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels provides competitive and transparent pricing for Urbania rentals in Baner, giving you excellent value for money without any hidden charges."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained, and Sanitized Vehicles",
    "WhyChoosedescription": "Our Urbania vehicles are regularly serviced and sanitized to maintain high standards of hygiene, safety, and passenger comfort."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Route Options",
    "WhyChoosedescription": "We offer flexible pickup and drop-off locations with customized routes to suit your travel plan within Baner, Pune, or nearby destinations."
  },
  {
    "WhyChooseheading": "Easy Booking with Dedicated Support",
    "WhyChoosedescription": "Booking an Urbania on Rent in Baner Pune is simple and hassle-free with Amruta Travels. Our support team assists you at every step for a seamless experience."
  }
]

    }

const faqData = [
  {
    question: 'How can I book an Urbania on rent in Baner Pune?',
    answer: 'You can book an Urbania on rent in Baner Pune by contacting Amruta Travels online, via phone, or by visiting our office. Our team will assist you throughout the booking process.'
  },
  {
    question: 'Is Urbania suitable for corporate travel from Baner?',
    answer: 'Yes, Urbania is ideal for corporate travel, offering spacious seating, air conditioning, and comfort for employees and clients traveling from Baner.'
  },
  {
    question: 'Can I rent Urbania in Baner for outstation trips?',
    answer: 'Yes, we provide Urbania rentals from Baner for both local and outstation travel, ensuring a smooth and comfortable journey.'
  },
  {
    question: 'Does the Urbania rental include a driver?',
    answer: 'Yes, every Urbania rental includes a professional and experienced driver for safe and hassle-free travel.'
  },
  {
    question: 'Are the Urbania vehicles well-maintained?',
    answer: 'Absolutely. All Urbania vehicles are regularly serviced, cleaned, and sanitized to maintain hygiene, safety, and passenger comfort.'
  },
  {
    question: 'What is the cost of Urbania on rent in Baner Pune?',
    answer: 'The rental cost depends on distance, duration, and type of travel. Contact Amruta Travels for a transparent and customized quote.'
  },
  {
    question: 'Can I customize pickup and drop-off locations in Baner?',
    answer: 'Yes, we offer flexible pickup and drop-off options and route customization based on your travel needs.'
  },
  {
    question: 'Why choose Amruta Travels for Urbania rental in Baner Pune?',
    answer: 'Amruta Travels offers well-maintained Urbania vehicles, professional drivers, transparent pricing, and reliable support, ensuring a premium travel experience.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sameer Deshmukh',
    role: 'Corporate Executive, Baner',
    text: 'We rented an Urbania from Baner for a corporate event. The vehicle was spacious, clean, and comfortable. The driver was punctual and professional. Excellent service by Amruta Travels!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Rutuja More',
    role: 'Family Traveler, Baner',
    text: 'Booked an Urbania on rent in Baner for a family outing. The ride was smooth, comfortable, and hassle-free. Highly recommend Amruta Travels!',
    rating: 5
  }
];
























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const schemaData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "LocalBusiness",
      "name": "Amruta Travels",
      "image": "https://bushireinpune.com/assets/images/urbania-baner.jpg",
      "url": "https://bushireinpune.com/urbania-on-rent-baner",
      "telephone": "+91 7353109555",
      "priceRange": "₹₹",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Baner",
        "addressRegion": "Maharashtra",
        "addressCountry": "IN"
      },
      "areaServed": [
        { "@type": "Place", "name": "Baner" },
        { "@type": "Place", "name": "Balewadi" },
        { "@type": "Place", "name": "Aundh" },
        { "@type": "Place", "name": "Pashan" },
        { "@type": "Place", "name": "Hinjewadi Phase 1" }
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "ratingCount": "7685"
      }
    },
    {
      "@type": "Service",
      "serviceType": "Urbania Rental Baner Pune",
      "provider": {
        "@type": "LocalBusiness",
        "name": "Amruta Travels"
      },
      "areaServed": {
        "@type": "Place",
        "name": "Baner Pune"
      },
      "description": "Book Force Urbania on rent in Baner Pune for corporate travel, airport transfers, weddings, family trips and outstation journeys."
    },
    {
      "@type": "Product",
      "name": "Urbania on Rent in Baner Pune",
      "image": "https://bushireinpune.com/assets/images/urbania-baner.jpg",
      "description": "Hire 13 and 17 seater Force Urbania vans in Baner Pune with AC, pushback seats and experienced drivers at best price.",
      "brand": {
        "@type": "Brand",
        "name": "Amruta Travels"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "ratingCount": "7685"
      },
      "offers": {
        "@type": "Offer",
        "priceCurrency": "INR",
        "price": "6200",
        "availability": "https://schema.org/InStock",
        "url": "https://bushireinpune.com/urbania-on-rent-baner"
      }
    },
    {
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Is Urbania available in Baner Pune?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Urbania rental is available in Baner, Balewadi, Aundh, Pashan and Hinjewadi areas."
          }
        },
        {
          "@type": "Question",
          "name": "What is the price of Urbania in Baner Pune?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Urbania rental in Baner Pune starts from ₹6200 depending on trip type and seating capacity."
          }
        },
        {
          "@type": "Question",
          "name": "Can I book Urbania for corporate travel in Baner?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Urbania is widely used for corporate travel in Baner and Hinjewadi IT Park."
          }
        }
      ]
    }
  ]
};




    return (
        <div>


<Helmet>
  <title>
    Urbania on Rent in Baner Pune | Force Urbania Hire Near Hinjewadi | Call 7353109555
  </title>

  <meta
    name="description"
    content="Book Urbania on rent in Baner Pune near Hinjewadi IT Park. Hire 13 & 17 seater Force Urbania vans for corporate travel, airport transfer, weddings & Pune to Mumbai, Goa, Shirdi trips."
  />

  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>

            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/116.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Urbaniaonrentinbanerpune;